import React from 'react';

const toggleReducer = (state: boolean, nextValue?: boolean) => nextValue ?? !state

export function useToggle(initialValue = false): [boolean, (nextValue?: boolean) => void] {
  return React.useReducer(toggleReducer, initialValue);
}
